import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

import { Button } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LIVE_SECTION_LABEL } from "../../utility/siteCopy";
import WebsiteBrandLogo from "../common/WebsiteBrandLogo";

function HomeHeader() {
  const [active, setActive] = useState(null);
  const accountData = useSelector((state) => state.auth);

  useEffect(() => {
    const scrollActive = () => {
      setActive(window.scrollY > 20);
    };
    window.addEventListener("scroll", scrollActive);
    return () => window.removeEventListener("scroll", scrollActive);
  }, [active]);
  return (
    <Navbar
      expand="xl"
      className={`${active ? "header_nav active" : "header_nav"} `}>
      <Container className="custom_container">
        <Navbar.Brand href="#" className="d-xl-none">
          <WebsiteBrandLogo linkTo="/" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="d-xl-none hh_mob_toggle"
        />
        <Navbar.Collapse id="basic-navbar-nav" className="d-xl-none">
          <Nav className="d-xl-none">
            <Nav className="hh_mob_nav">
              <NavLink to="/">Home</NavLink>
              {accountData && accountData.isAuth && (
                <>
                  <NavLink to="/straight-bet/A-Z Betting">Dashboard</NavLink>
                  <NavLink to="/straight-bet/livemobius">{LIVE_SECTION_LABEL}</NavLink>
                </>
              )}
              <NavLink to="/faq">Faq</NavLink>
              <NavLink to="/contact_us">Contact Us</NavLink>
            </Nav>

            {accountData && accountData.isAuth ? (
              ""
            ) : (
              <div className="d-flex align-items-center gap-3 flex-column flex-sm-row mt-2 mt-sm-3 mb-4">

                <Link to="/login">
                  <button className="img_btn img_btn_fw loginBtn">Login Now</button>
                </Link>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>

        {/* end of mobile view */}

        {/* start of web view */}

        <div className="d-none d-xl-flex justify-content-between align-items-center w-100">
          <Navbar.Brand href="/">
            <WebsiteBrandLogo linkTo="/" />
          </Navbar.Brand>
          <Nav className="hh_nav">
            <NavLink to="/">Home</NavLink>
            {accountData && accountData.isAuth && (
              <>
                {/* <NavLink to="/dashboard">Dashboard</NavLink> */}
                <NavLink to="/straight-bet/A-Z Betting">Dashboard</NavLink>
                <NavLink to="/straight-bet/livemobius">{LIVE_SECTION_LABEL}</NavLink>
              </>
            )}
            <NavLink to="/faq">Faq</NavLink>
            <NavLink to="/contact_us">Contact Us</NavLink>
          </Nav>


          {accountData && accountData?.isAuth ? (
            ""
          ) : (
            <div className="d-flex align-items-center gap-3 flex-column flex-sm-row mt-2 mt-sm-3 mb-4">
              <Link to="/login">
                <button className="img_btn img_btn_fw loginBtn">Login Now</button>
              </Link>
            </div>
          )}




        </div>
      </Container>
    </Navbar>
  );
}

export default HomeHeader;
